export default [
    { title: "Derecho de la empresa" },
   

    
  ];